module.exports = __webpack_public_path__ + "static/media/Trisha Hernandez.277dde0b.jpg";